import { useServices, useSession } from "../app/services";
import { Link, useLocation } from "react-router";
import { Icon } from "../components/Icon";
import { Highlight } from "../motion/Highlight";
import { Ribatan, SkyBits } from "../components/stage";
import { Loading } from "../components/ui";

/**
 * ログインしていない・サーバーのメンバーでない・確かめられないときの画面。
 * 入口なので、参照元のトップと同じく広場の絵を大きく敷き、りばたんが迎える。
 * 保護されたデータ（投稿・キュー・ライブラリ）は出さない（仕様書「認証と所属確認」）
 */
export function SignInGate() {
  const session = useSession();
  const { api, session: store } = useServices();
  const location = useLocation();
  const sharedPost = /^\/posts\/[^/]+\/?$/.test(location.pathname);

  if (session.status === "loading") {
    return (
      <div className="gate">
        <div className="gate__card">
          <Loading label="ログイン状態を確認しています…" rows={2} />
        </div>
      </div>
    );
  }

  const baseLoginUrl = api.loginUrl();
  const draftEditor = /^\/moments\/[0-9a-fA-F-]{36}\/?$/.test(location.pathname);
  const loginUrl = baseLoginUrl && (sharedPost || draftEditor || location.pathname === "/posts")
    ? `${baseLoginUrl}${baseLoginUrl.includes("?") ? "&" : "?"}return_to=${encodeURIComponent(location.pathname)}`
    : baseLoginUrl;

  return (
    <div className="gate">
      <SkyBits count={12} seed={3} />
      <div className="gate__card">
        <Ribatan
          pose={session.status === "signed_out" ? "hello" : "lost"}
          className="gate__ribatan"
          sizes="(max-width: 600px) 38vw, 180px"
        />
        {session.status === "signed_out" && (
          <>
            <h1 className="gate__title" tabIndex={-1} data-page-title>
              {sharedPost ? "届いた「ここ好き」を見に行こう。" : "好きな曲を、一緒に。"}
            </h1>
            <p>
              {sharedPost ? "この投稿はサーバーメンバー限定です。Discordでログインすると、この投稿に戻ります。" : "ほろりばレコードは、みんなで曲を聴いて、好きな瞬間を持ち寄る場所。音楽はDiscordのVCで流れます。"}
            </p>
            {loginUrl ? (
              <Highlight kind="ring">
                <a className="btn btn-primary" href={loginUrl}>
                  Discordでログインする
                </a>
              </Highlight>
            ) : (
              <p className="inline-note inline-note--warn">ログインは、まだAPIに接続されていません。</p>
            )}
            <p className="gate__small">ログインでは、あなたのDiscordのユーザー情報と、このサーバーに所属しているかだけを確認します。</p>
            <Link to="/guide">初めての方へ・使い方を見る →</Link>
          </>
        )}
        {session.status === "not_member" && (
          <>
            <h1 className="gate__title" tabIndex={-1} data-page-title>
              このサーバーのメンバー専用です
            </h1>
            <p>
              ログインしたDiscordアカウントが、対象のサーバーに所属していることを確認できませんでした。サーバーに参加してから、もう一度お試しください。
            </p>
          </>
        )}
        {session.status === "unavailable" && (
          <>
            <h1 className="gate__title" tabIndex={-1} data-page-title>
              {session.code === "not_connected" ? "APIにまだ接続されていません" : "ログイン状態を確認できません"}
            </h1>
            <p>
              {session.code === "not_connected"
                ? "API契約（contracts/openapi.json）が届いて接続するまで、本物のデータは表示できません。開発中は `npm run dev`（モック）で画面を確かめられます。"
                : "通信が不安定か、サーバーが応答していません。確認できるまで、メンバー向けの内容は表示しません。"}
            </p>
            {session.code !== "not_connected" && (
              <button type="button" className="btn btn-secondary" onClick={() => void store.load()}>
                <Icon name="refresh" className="btn-icon" />
                もう一度確かめる
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
